import { Skeleton } from '@mui/material';
import './ModuleContents.scss';
import { ModuleCTA } from 'components/ModuleCTA/ModuleCTA';
import { TableOfContents } from 'pages/TableOfContents/TableOfContents';
import { LearningModuleContentsEntry, ModuleTableOfContents } from 'types/learningHub/moduleContents';
import { useNavigate } from 'react-router-dom';
import { Chip } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';

type ModuleContentsProps = {
  contents: ModuleTableOfContents | undefined;
  isModuleCompleted: boolean;
  isModuleStarted: boolean;
  slug: string;
  isPending: boolean;
};

export const ModuleContents = ({ contents, isModuleCompleted, isModuleStarted, slug, isPending }: ModuleContentsProps) => {
  const navigate = useNavigate();

  const handleEntrySelection = (newlySelectedEntry: LearningModuleContentsEntry) => {
    navigate(`Module?itemId=${newlySelectedEntry.id}`, { relative: 'path' });
  };

  return (
    <div className='module-contents'>
      {!isPending && contents ? (
        <>
          <ModuleCTA isModuleCompleted={isModuleCompleted} isModuleStarted={isModuleStarted} slug={slug}></ModuleCTA>
          {contents.progress ? <ModuleProgress isModuleCompleted={isModuleCompleted} progress={contents.progress} /> : <></>}
          <TableOfContents contents={contents} handleEntrySelection={handleEntrySelection}></TableOfContents>
        </>
      ) : (
        <Skeleton width='100%' sx={{ height: 770 }} variant='rounded' />
      )}
    </div>
  );
};

const ModuleProgress = ({ isModuleCompleted, progress }: { isModuleCompleted: boolean; progress: number }) => {
  const { t } = useTranslation();

  return (
    <div className='module-progress'>
      <Chip
        label={
          isModuleCompleted
            ? t('CertificationComplete', { ns: 'learningHub' })
            : t('InProgress', { ns: 'learningHub', progress: progress.toFixed(0) })
        }
        clickable={false}
        className={isModuleCompleted ? 'module-progress-label module-progress-label--completed' : 'module-progress-label'}
      />
      <div className='progress-line' style={{ '--progress': `${progress}%` } as React.CSSProperties}></div>
    </div>
  );
};
